<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
    name: 'app'
}

</script>


<style lang="stylus">
@font-face
    font-family: 'Material Icons'
    font-style: normal
    font-weight: 400
    src: local('Material Icons'), local('MaterialIcons-Regular'), url(https://fonts.gstatic.com/s/materialicons/v17/2fcrYFNaTjcS6g4U3t-Y5ZjZjT5FdEJ140U2DJYC3mY.woff2) format('woff2')


.material-icons
    font-family: 'Material Icons'
    font-weight: normal
    font-style: normal
    font-size: 1em
    line-height: 1
    letter-spacing: normal
    text-transform: none
    display: inline-block
    vertical-align: middle
    white-space: nowrap
    word-wrap: normal
    direction: ltr
    /* -webkit-font-feature-settings: 'liga'
    -webkit-font-smoothing: antialiased */


body, html
    margin: 0
    padding: 0
    font-family: 'Nunito', sans-serif
    color: #013160

main
    padding 0 2em

.container
    max-width: 80em
    margin: 0 auto


</style>



// WEBPACK FOOTER //
// src/App.vue